import { motion } from "framer-motion";
import { LOGO_URL } from "../lib/assets";
import { MaskLines } from "../components/Motion";
import { WaitlistForm } from "../components/WaitlistForm";
import { DropTeaser } from "../components/DropTeaser";
import { SocialIcons } from "../components/Contact";

export default function ComingSoon() {
  return (
    <main data-testid="coming-soon-page" className="relative min-h-[100svh] bg-[#E10600] text-white overflow-hidden grain">
      <div className="relative z-10 min-h-[100svh] grid lg:grid-cols-12 gap-12 items-center px-5 sm:px-10 lg:px-16 pt-32 pb-14">
        <div className="lg:col-span-7">
        <motion.div initial={{ rotate: -20, scale: 0.6, opacity: 0 }} animate={{ rotate: 0, scale: 1, opacity: 1 }} transition={{ type: "spring", stiffness: 120, damping: 14, delay: 0.3 }} className="mb-8">
          <div className="inline-flex flex-col items-start gap-2 bg-white text-[#0B0B0B] px-4 py-3 shadow-[6px_6px_0_#0B0B0B]" data-testid="coming-soon-logo">
            <img src={LOGO_URL} alt="Project X — Make Parties Great Again" className="h-12 sm:h-14 w-auto" />
            <span className="font-display uppercase text-2xl bg-[#E10600] text-white px-2">Coming soon</span>
          </div>
        </motion.div>
        <p className="font-mono-x uppercase text-xs sm:text-sm tracking-[0.3em] font-bold">Drop 002 · Date TBA · Stay ready</p>
        <h1 className="font-display uppercase leading-[0.82] text-[22vw] lg:text-[11rem] mt-4" data-testid="coming-soon-headline">
          <MaskLines lines={["Coming", <span key="s" className="text-[#0B0B0B] animate-flicker">soon.</span>]} delay={0.5} />
        </h1>
        <p className="mt-8 max-w-lg text-lg sm:text-xl font-bold">
          The next Project X merch drop is loading. New heat for the whole squad — you'll hear about it before anyone else.
        </p>
        <div className="mt-8"><WaitlistForm /></div>
        <div className="mt-8 flex items-center gap-4">
          <span className="font-mono-x uppercase text-xs tracking-[0.25em] font-bold">Follow the hype</span>
          <SocialIcons prefix="coming-soon" />
        </div>
        </div>
        <motion.div className="lg:col-span-5 w-full max-w-md mx-auto" initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.9 }}>
          <DropTeaser />
        </motion.div>
      </div>
    </main>
  );
}
